import BaseRoute from '../routing';
import {State, Module} from '../decorators.js';
import errorMessages from 'app/directives/error.messages';
import AuthService from '../services/auth';
import loginTpl from './login.form.html';
import passwordResetTpl from './reset.password.form.html';
import passwordResetConfirmTpl from './reset.password.confirm.html'

import {LoginCtrl, PasswordResetCtrl, PasswordConfirmCtrl} from './ctrls'


@Module({
    name: 'app.login',
    modules: [
        BaseRoute,
        AuthService,
        errorMessages,
    ],
})
@State({
    name: 'r.login',
    url: '/login?next',
    controller: LoginCtrl,
    className: 'auth-page',
    template: loginTpl,
    auth: false,
    ncyBreadcrumb: {
        label: 'Login',
    },
    resolve: {
        isLogged: function($q, $state, AuthService){
            "ngInject";
            if (AuthService.isLoggedIn) {
                $state.go('r.in', {force: true});
                return $q.reject();
            }
        },
    },
})
@State({
    name: 'r.password',
    url: '/password',
    template: '<div ui-view></div>' ,
    auth: false,
    resolve: {},
    abstract: '.reset',
    ncyBreadcrumb: {
        skip: true,
    }
})
@State({
    name: 'r.password.reset',
    url: '/reset',
    controller: PasswordResetCtrl,
    template: passwordResetTpl,
    className: 'auth-page',
    auth: false,
    ncyBreadcrumb: {
        label: 'Reset Password',
    },
    resolve: {},
})
@State({
    name: 'r.password.confirm',
    url: '/confirm/:uid/:token',
    controller: PasswordConfirmCtrl,
    template: passwordResetConfirmTpl,
    className: 'auth-page',
    auth: false,
    ncyBreadcrumb: {
        label: 'Confirm',
    },
    resolve: {},
})
export default class States {
}



// WEBPACK FOOTER //
// ./src/app/auth/routing.js